<template>
  <form class="mt-2" id="form-modal" @submit.prevent="submitForm">
    <div class="col-md-12 px-0">
      <div class="col-md-12 style-label">
        <label class="label-form" for="delivery_date">Delivery Date:</label>
        <input
            id="delivery_date"
            type="datetime-local"
            v-model="due_date"
            class="form-control"
            :min="min_date"
        />
      </div>
      <div class="text-right">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
        >
          Close
        </button>
        <button
            type="submit"
            class="btn btn-default ml-1"
        >
          <font-awesome-icon
              v-if="mini_loading"
              icon="spinner"
              style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;"
          />
          {{ action !== 'edit' ? "Save" : "Update" }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    formData: Object,
    action: String,
    minDate: String,
  },
  data() {
    return {
      mini_loading: false,
      due_date: null,
    };
  },
  computed: {
    min_date() {
      return this.minDate || moment().format("YYYY-MM-DDTHH:mm");
    }
  },
  mounted() {
    this.initializeDueDate();
  },
  created() {
    this.initializeDueDate();
  },
  watch:{
    formData: {
      handler(newVal) {
        this.initializeDueDate();
      },
      deep: true, // Enables deep watching of the object properties
    },
  },
  methods: {
    initializeDueDate() {
      const {deliveryDate, deliveryTime} = this.formData;
      console.log(this.formData);
      this.due_date = moment(`${deliveryDate} ${deliveryTime}`).format("YYYY-MM-DDTHH:mm");
    },

    validateForm() {
      if (!this.due_date) {
        this.$toast.error('Please select a delivery date.');
        return false;
      }
      return true;
    },

    submitForm() {
      if (!this.validateForm()) return;

      this.mini_loading = true;

      this.$store.dispatch("support/changeTicketDeliveryDate", {
        ticket_id: this.formData.id,
        delivery_date: moment(this.due_date).format("YYYY-MM-DDTHH:mm"),
      })
          .then(() => {
            this.$toast.success('Ticket delivery date has been updated successfully');
            this.mini_loading = false;
            window.$('#modal').modal('hide');
            this.$store.dispatch("support/getAllTickets", [this.formData.currentPage, 'all', '', false])
          })
          .catch(() => {
            this.$toast.error('OOPS! Something went wrong');
            this.mini_loading = false;
            window.$('#modal').modal('hide');
          });
    },

    resetForm(){
      this.due_date = null;
    }

  },
};
</script>
